import React from 'react';

function RDSCertified(props) {
  const { isrds, isrsd, isgrs, treatment, changeWord, t, checked } = props;
  const isRDS = !!isrds;
  const isRSD = !!isrsd;
  const isGRS = !!isgrs;
  const isTreatment = treatment && treatment.length > 0 && !!treatment[0] && (treatment[0] !== "None" && treatment[0] !== "none");

  // Helper for label text using the t function
  const getLabel = () => {
    if (isGRS) {
      return isTreatment ? t("certs.grs_bluesign") : t("certs.grs_oeko");
    }
    
    if (isRSD) {
      if (isRDS || isTreatment) return t("certs.rsd");
      return t("certs.rsd_oeko");
    }

    if (isRDS) {
      return isTreatment ? t("certs.rds") : t("certs.rds_oeko");
    }

    return "bluesign® / OEKO-TEX® Standard 100";
  };

  const label = getLabel();

  return (
    <>
      <input 
        type="radio" 
        id="certifications" 
        name="tmd" 
        value="CERTIFICATIONS" 
        checked={checked}
        onChange={() => changeWord("CERTIFICATIONS")} 
      />
      <label className="cr-list" htmlFor="certifications">
        {label}
      </label>
    </>
  );
}

export default RDSCertified;
